<template lang="pug">
  .page-account
    h1 Sign In
    form(@submit.prevent="submit")
      .row(v-bind:class="v$.email.$error ? 'has_error' : ''")
        label(for="user_email") Email (Required)
        input(type="email" name="email" id="user_email" v-model="email" aria-describedby="user_email_error")
        p.error(v-for="error of v$.email.$errors" :key="error.$uid" v-html="error.$message" id="user_email_error")
      .row(v-bind:class="v$.password.$error ? 'has_error' : ''")
        label(for="user_password") Password (Required)
        input(type="password" name="password" id="user_password" v-model="password" aria-describedby="user_password_error")
        p.error(v-for="error of v$.password.$errors" :key="error.$uid" v-html="error.$message" id="user_password_error")
      .row
        input.btn--primary(type="submit" value="Sign In" style="margin-bottom: 1em")
        button.btn--primary(style="margin-top: 0" @click.prevent="$parent.setPage('signup')") Create Account
      .row.link
        | Forgot Password? <a href="#" @click.prevent="$parent.setPage('forgot')">Click here</a>
</template>

<script>
  import { email, required, minLength } from '@vuelidate/validators';
  import { useVuelidate } from '@vuelidate/core';
  import { mandatory } from '../../helpers/validators.js';

  export default {
    name: 'Signin',

    components: {
    },

    props: {
    },

    data: {
    },

    setup() {
      return {
        v$: useVuelidate({ $autoDirty: true })
      }
    },

    mounted() {
      this.$parent.createRecaptcha();
    },

    data() {
      return {
        email: '',
        password: '',
        vuelidateExternalResults: {
          email: [],
          password: []
        }
      }
    },

    validations () {
      return {
        email: { required: mandatory('Email'), email },
        password: { required: mandatory('Password'), minLength: minLength(8) }
      }
    },

    methods: {
      async submit() {
        Object.assign(this.vuelidateExternalResults, {});
        const result = await this.v$.$validate();
        if (!result) {
          const firstErrorProperty = this.v$.$errors[0].$property;
          this.$el.querySelector(`[name=${firstErrorProperty}]`).focus();
          return;
        }

        this.$parent.getRecaptchaToken((token) => {
          const data = {
            email: this.email,
            password: this.password,
            recaptcha_token: token
          };
          console.log('submit', data, this.$parent)

          fetch(
            this.$parent.url + 'signin', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
            }
          ).then(response => response.json()).then(data => {
            if (data.error) {
              Object.assign(this.vuelidateExternalResults, { email: data.error_description });
            } else {
              data.email = this.email;
              this.$parent.setSession(data);

              window.location = data.shopify_url;
              // this.$parent.setPage('profile');
            }
          }).catch(() => {
          });
        });

      }
    }
  }
</script>

<style scoped lang="scss">
</style>
